export default __webpack_public_path__ + "static/media/Path 20295.5de5bea9.png";